import ZColor from "zobject/custom/ZColor.js";
import Colors from "components/Colors.js"
import {doc} from '../docs.js';

const COLORS = new Colors();

doc(
    "color",
    {
    },
    "Outputs a color",
    () => 0,
    {
        connects: {
            object: "gl.color"
        },
        tags: "Colors"
    }
);
export const color = (object) => {
    let zcolor = new ZColor(object);
    object.effect = zcolor;
    object.needsLoad = true;
    object.needsStart = true;
    object.width = 230;
    object.height= 180;

    return ([type]) => {
        zcolor.color = zcolor.color;
    };
};

doc(
    "compliment",
    {
        rotate: ""
    },
    "Rotates a color (0-10), complimenting it",
    undefined,
    {
        isHot: true,
        inlets: 2,
        tags: "Colors"
    }
);

const compliment = (object, rotate) => {
    return (msg) => {
        return COLORS.hslToHex(
            COLORS.compliment(
                COLORS.saturate(msg[0], 1),
                rotate()
            )
        );
    };
};



export const colors = {
    color,
    compliment
};
